export class UserOverride {
    
    public overrideEmployeMaximumAllowedAmount: number | null;
 
    constructor( 
        overrideEmployeMaximumAllowedAmount: number | null
    )   
    {
        this.overrideEmployeMaximumAllowedAmount = overrideEmployeMaximumAllowedAmount;
    }
 
}